import { useSiteSettings, splitBrandName } from '@/context/SiteSettingsContext';

interface BrandIconProps {
  size?: string;
  textSize?: string;
}

export function BrandIcon({ size = 'w-9 h-9', textSize = 'text-sm' }: BrandIconProps) {
  const { settings } = useSiteSettings();

  if (settings.logo) {
    return (
      <img
        src={settings.logo}
        alt={settings.nomSite}
        className={`${size} rounded-full object-cover flex-shrink-0`}
      />
    );
  }

  return (
    <div className={`${size} rounded-full border-2 border-brand-gold flex items-center justify-center flex-shrink-0`}>
      <span className={`text-brand-gold font-heading font-bold ${textSize}`}>
        {settings.nomSite.charAt(0).toUpperCase()}
      </span>
    </div>
  );
}

interface BrandNameProps {
  suffix?: string;
  className?: string;
}

export function BrandName({ suffix, className = '' }: BrandNameProps) {
  const { settings } = useSiteSettings();
  const [first, rest] = splitBrandName(settings.nomSite);
  return (
    <span className={className}>
      {first} <span className="text-brand-gold">{suffix || rest}</span>
    </span>
  );
}
